import { useCallback, useEffect, useRef } from 'react';

export default function useAppInitialization({ location, navigate, setRefreshKey, setSummaryRefreshKey }) {
  const summaryRefreshTimerRef = useRef(null);

  const refreshForNewTickets = useCallback((refreshList = false) => {
    if (refreshList) setRefreshKey(value => value + 1);
    clearTimeout(summaryRefreshTimerRef.current);
    summaryRefreshTimerRef.current = setTimeout(() => {
      setSummaryRefreshKey(value => value + 1);
    }, 3000);
  }, [setRefreshKey, setSummaryRefreshKey]);

  useEffect(() => () => clearTimeout(summaryRefreshTimerRef.current), []);

  useEffect(() => {
    const ticketId = new URLSearchParams(location.search).get('ticket');
    if (ticketId && !location.pathname.startsWith('/tickets/')) {
      navigate(`/tickets/${encodeURIComponent(ticketId)}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return { refreshForNewTickets };
}
